<template>
  <div id="videos">
    <div id="subscriber"></div>
    <div id="publisher"></div>
  </div>
</template>

<script>
import OT from "@opentok/client";
import store from "@/store/index.js";
// import router from '@/router'

export default {
  name: "Programming",
  data() {
    return {
      videoNotPublished: true,
      patientIsNotConnected: true,
      patientWasNeverConnected: true,
      programmingMode: false,
      videoIcon: "camera-video",
      audioIcon: "mic",
      device: "-",
      serialNumber: "-",
      session: null,
      publisher: null,
    };
  },
  created() {
    this.reinitializeVideoSession();
  },
  methods: {
    reinitializeVideoSession() {
      this.session = store.state.videoSession;
      var self = this;
      // Subscribe to a newly created stream

      // this.session.on("streamCreated", function (event) {
      //   self.patientIsNotConnected = false;
      //   self.patientWasNeverConnected = false;
      //   self.session.subscribe(
      //     event.stream,
      //     "subscriber",
      //     {
      //       insertMode: "append",
      //       width: "100%",
      //       height: "100%",
      //     },
      //     (error) => (error ? alert(error.message) : null)
      //   );
      // });

      // var publisherProperties = {
      //   // insertMode: 'append',
      //   width: "100%",
      //   height: "100%",
      // };
      // self.publisher = OT.initPublisher("publisher", publisherProperties);
      // self.session.publish(self.publisher);
      // self.videoNotPublished = false;

      this.session.connect(store.state.videoToken, function (error) {
        if (error) {
          console.error(error.message);
        } else {
          var publisherProperties = {
            // insertMode: 'append',
            width: "100%",
            height: "100%",
          };
          self.publisher = OT.initPublisher("publisher", publisherProperties);
          self.session.publish(self.publisher);
          self.videoNotPublished = false;
          // This example assumes that a DOM element with the ID 'publisherElement' exists
        }
      });
    },

    toggleVideo() {
      if (this.videoIcon === "camera-video") {
        this.publisher.publishVideo(false);
        this.videoIcon = "camera-video-off";
      } else {
        this.publisher.publishVideo(true);
        this.videoIcon = "camera-video";
      }
    },

    toggleAudio() {
      if (this.audioIcon === "mic") {
        this.publisher.publishAudio(false);
        this.audioIcon = "mic-mute";
      } else {
        this.publisher.publishAudio(true);
        this.audioIcon = "mic";
      }
    },

    turnStimulationOn() {
      const command = new Uint8Array([
        0x28, 0x10, 0x23, 0x00, 0x4a, 0x00, 0x00, 0x00, 0x01, 0x01, 0x0f, 0x0f,
        0x2c, 0x01, 0x70, 0xa9,
      ]);
      store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
        console.log(msg);
        console.log(msg.data);
      });
      store.state.ablyChannel.publish("telemetry-request", {
        command: Array.from(command),
      });
    },

    turnStimulationOff() {
      const command = new Uint8Array([
        0x28, 0x10, 0x23, 0x00, 0x4a, 0x00, 0x00, 0x00, 0x01, 0x01, 0x0f, 0x0f,
        0x26, 0x02, 0xd8, 0x76,
      ]);
      store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
        console.log(msg);
        console.log(msg.data);
      });
      store.state.ablyChannel.publish("telemetry-request", {
        command: Array.from(command),
      });
    },

    increaseAmplitude() {
      const command = new Uint8Array([
        0x28, 0x1b, 0x19, 0x00, 0x5e, 0x00, 0x00, 0x00, 0x00, 0x04, 0xa8, 0x00,
        0x00, 0x00, 0xb0, 0x00, 0x00, 0x00, 0x0e, 0x01, 0x00, 0x00, 0x10, 0x01,
        0x00, 0x00, 0x26, 0xa5,
      ]);
      store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
        console.log(msg);
        console.log(msg.data);
      });
      store.state.ablyChannel.publish("telemetry-request", {
        command: command,
      });
    },

    decreaseAmplitude() {
      const command = new Uint8Array([
        0x28, 0x0b, 0x2c, 0x01, 0x04, 0x00, 0x8e, 0x87, 0x01, 0xe2, 0x1a,
      ]);
      store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
        console.log(msg);
        console.log(msg.data);
      });
      store.state.ablyChannel.publish("telemetry-request", {
        command: command,
      });
    },
  },
};
</script>

<style scoped>
#subscriber {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

#publisher {
  position: absolute;
  width: 360px;
  height: 240px;
  bottom: 10px;
  left: 10px;
  z-index: 100;
  border: 3px solid white;
  border-radius: 3px;
}
</style>
